import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RadialProgressComponent } from './radial-progress/radial-progress.component';
import { FormGroupDirective } from '@angular/forms';
import { BookingStepsFormType } from '@app/shared/models/booking-steps-form-type.model';
import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { TranslateModule } from '@ngx-translate/core';
import { BookingFormStepEnum } from '@app/shared/models/booking-form-step.enum';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RadialProgressComponent,
    TranslateModule
  ]
})
export class BookingPartStepperComponent implements OnInit {

  @Input() salonDetails: ISalonDetailsApi;

  public parentForm: BookingStepsFormType;
  public readonly parentFormDirective = inject(FormGroupDirective);

  public stepsCount: number;
  public currentStepIndex: BookingFormStepEnum;
  public isLoggedIn$: Observable<boolean>;
  public salonName: string;

  ngOnInit(): void {
    this.parentForm = this.parentFormDirective.form;
    this.stepsCount = 2;
    this.currentStepIndex = this.parentForm.controls.activeStep.value;
    this.salonName = this.salonDetails?.name ?? '';
  }
}
